/** @jsxImportSource @emotion/react */
import React from "react";
import { Drawer as BaseDrawer, DrawerProps } from "antd";
import { css } from "@emotion/react";

type Props = {
  buttons?: React.ReactNode;
} & DrawerProps;

const drawerButtonsStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 100%;
`;

const bodyStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const Drawer = ({ buttons, children, ...rest }: Props) => {
  return (
    <BaseDrawer
      extra={buttons && <div css={drawerButtonsStyle}>{buttons}</div>}
      {...rest}
    >
      <div css={bodyStyle}>{children}</div>
    </BaseDrawer>
  );
};
